import styled from 'styled-components/macro';

import { BlockSpinner } from './BlockSpinner';

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 75vh;
`;

/** Like a `BlockSpinner` but designed to be the page content while data is first being fetched. */
export const PageSpinner = () => (
  <StyledContainer>
    <BlockSpinner />
  </StyledContainer>
);
